import { Action } from '@/_core/fluxstore/types';
import { AppLoaderState } from '../types';
import { useAppLoaderModule } from '..';

const { registerReducer } = useAppLoaderModule();

export class OpenAppLoader extends Action<AppLoaderState> {
    public static ACTION_TYPE = 'OpenAppLoader';

    public constructor(public delay: number = 300) {
        super(OpenAppLoader.ACTION_TYPE);
    }
}

const reducer = (state: AppLoaderState, action: OpenAppLoader): void => {
    state.isLoading = true;
    state.delay = action.delay;
};

//@ts-ignore
registerReducer(OpenAppLoader.ACTION_TYPE, reducer);
